import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useClientData } from '../../../../providers/ClientData.provider';
import ReconciliationTransactionTable from './ReconciliationTransactionTable';
import BatchFileLists from './BatchFileLists';
import useFetchBatchFileTransactions from '../../../../hooks/useApi/useFetchBatchFileTransactions';

const { Box, Title, Button } = vp;

type LocationProps = {
  id: string;
  service: string;
  paymentType: string;
};

type FC = FunctionComponent;

const GroupDetailsContainer: FC = () => {
  const history = useHistory();
  const { response } = useClientData();
  const { state } = useLocation<LocationProps>();
  const [batchFileResponse, fetchBatchFile] = useFetchBatchFileTransactions({});

  useEffect(() => {
    fetchBatchFile({
      PortalUser: response.LoginUserName || '',
      BatchID: state.id || '',
      TransactionType: state.paymentType || '',
      PaymentType: state.paymentType || '',
    });
  }, [state]);

  return (
    <>
      <Box mb="md" jc="sb" ai="center">
        <Box mb="md" jc="sb">
          <Title title="Batch File" />
        </Box>
        <Button
          id="view-reconciliation"
          label="View Reconciliation"
          onClick={() => {
            history.goBack();
          }}
        />
      </Box>
      <Box flx="col">
        <ReconciliationTransactionTable />
        <BatchFileLists batchFiles={batchFileResponse.Transactions} />
      </Box>
    </>
  );
};

export default GroupDetailsContainer;
